import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gycan7rcyq: FaireBrandEntity = {
  token: "b_gycan7rcyq",
  type: "brand",
  name: "Clay by Shay",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f841f9316edaaac8436d55bbb507f74ced5db5ae9c3feffc2f8ce600b5c0ebe.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3924b456f6a8a38c2e43e0fc97a0c316cebf4c57e671d8337be3c79c3410d052.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6f841f9316edaaac8436d55bbb507f74ced5db5ae9c3feffc2f8ce600b5c0ebe.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3924b456f6a8a38c2e43e0fc97a0c316cebf4c57e671d8337be3c79c3410d052.jpeg",
  location: "Boise, ID, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Clay by Shay is handmade by a small team of creative women in Boise, ID. We use stoneware, porcelain and earthenware clay bodies, our designs are naturally waterproof, durable, and plastic-free. We offer an adventure-proof promise, guaranteeing the life of each piece of jewelry we make, reducing waste through free repairs and offering peace of mind that our jewelry is truly made to last lifetimes. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:15.341Z",
    importedBy: "entity-db-cli",
  },
};
